"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePropertyRepairUpdate = exports.propertyRepairUpdateSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
exports.propertyRepairUpdateSchema = {
    type: 'object',
    required: ['amount', 'cmhcLoanAccountNumber', 'offlineApprovalIndicator'],
    properties: {
        amount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            maximum: 99999999,
            minimum: 1000000,
            errorMessage: 'should be numeric between 1000000 to 99999999',
        },
        offlineApprovalIndicator: {
            type: 'boolean',
            errorMessage: 'should be either true or false',
        },
    },
};
exports.validatePropertyRepairUpdate = function (data) {
    var propertyRepairValidator = new schema_validator_1.SchemaValidator(exports.propertyRepairUpdateSchema, true, true, true, true);
    return propertyRepairValidator.validate(data);
};
